var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalizeMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9788 12.0653V6.16772H10.6455V12.0654C11.8883 11.4269 13.3063 11.0625 14.8122 11.0625C16.3181 11.0625 17.736 11.4269 18.9788 12.0653Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9788 2H10.6455V5.12611H18.9788V2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 12.1042C10.5052 12.1042 7 15.448 7 19.5522C7 23.6615 10.5052 27.0001 14.8125 27.0001C19.1198 27.0001 22.625 23.6615 22.625 19.5522C22.625 15.448 19.1198 12.1042 14.8125 12.1042ZM18.875 25.1251L14.8125 23.0626L10.75 25.1251L11.526 20.7553L8.21352 17.6459L12.7865 17.0001L14.8125 13.047L16.8385 17.0001L21.4114 17.6459L18.099 20.7553L18.875 25.1251Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizeMarks);
export default __webpack_public_path__ + "static/media/Finalize_Marks.574550e0a0f1e0cfefdb98ee7dd7d65d.svg";
export { ForwardRef as ReactComponent };